import { createWithEqualityFn } from 'zustand/traditional'
import { devtools } from 'zustand/middleware'

interface MenuState {
  opened: boolean
  toggle: () => void
  open: () => void
  close: () => void
}

export const useMenuStore = createWithEqualityFn<MenuState>()(
  devtools(
    (set) => ({
      opened: false,
      toggle: () => set((state) => ({ opened: !state.opened })),
      open: () => set(() => ({ opened: true })),
      close: () => set(() => ({ opened: false })),
    }),
    {
      name: 'menu-storage',
    },
  ),
  Object.is,
)
